'use client';

import { ReactNode } from 'react';
import { SWRConfig } from 'swr';
import makeCmsPageFallbackKey from '@helpers/makeCmsPageFallbackKey';
import type { PageWithSlots } from '@api/interfaces/pageApi';
import { CmsLabel } from '@constants/cmsLabels';

interface Props {
  /** Pass the same options you gave fetchCmsPage so the SWR key always matches. */
  label?: CmsLabel | string;
  code?: string;
  pageType?: string;
  /** Promise returned directly from fetchCmsPage() in the RSC — do NOT await it. */
  data: Promise<PageWithSlots>;
  children: ReactNode;
}

/**
 * Seeds the SWR cache with the pre-fetched CMS page data.
 *
 * Wrap each page's client subtree with this component so that useCmsPage()
 * reads from the server-started Promise without making a separate client request.
 *
 * Uses a nested SWRConfig so the root layout's homePage fallback is unaffected.
 */
export default function CmsPageFallback({ label, code, pageType, data, children }: Props) {
  return (
    <SWRConfig value={{ fallback: { [makeCmsPageFallbackKey({ label, code, pageType })]: data } }}>
      {children}
    </SWRConfig>
  );
}
